import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M119.4 175.7h.6c3 .3 5.1 2.9 4.3 5.5l-.3 1c-3.1 9.1-12.7 15.7-24 15.7h-1.2c-11.2-.5-20.5-7.4-23.2-16.7l-.1-.5c-.4-2.6 1.9-5.1 5-5.1h38.9zM100 2c1.9 0 3.8.7 5.2 2 1.4 1.3 2.2 3 2.2 4.7v7c37.7 3.4 66.2 33.6 66.2 68.4v47.8c.2 2.2 1.3 4.3 3.1 5.9 1.8 1.5 4.2 2.4 6.7 2.4h2.5c6.1.3 11.4 4.4 12.1 10l.1.7c.1 1.5-.2 3-.8 4.4-.6 1.4-1.5 2.7-2.6 3.8-1.1 1.1-2.5 1.9-4 2.5-1.5.6-3.1.9-4.8.9H14.2c-6.1-.3-11.4-4.4-12.1-10l-.1-.8c-.1-1.5.2-3 .8-4.4.6-1.4 1.5-2.7 2.6-3.8 1.1-1.1 2.5-1.9 4-2.5 1.5-.6 3.1-.9 4.8-.9h3.1c2.5-.2 4.8-1.2 6.5-2.8 1.7-1.6 2.6-3.8 2.6-6.1v-49c0-34.6 29-63.1 66.2-66.5v-7c0-1.8.8-3.5 2.2-4.7 1.4-1.3 3.3-2 5.2-2z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}